module.exports = __webpack_public_path__ + "img/Subtract.0e0c8be5.png";